<template>
  <div class="importDialog">
    <el-dialog
      :title="$t('lcd.Editor.import')"
      :visible.sync="importDialogVisible"
      width="90%"
      :before-close="handleClose"
    >
      <el-input
        type="textarea"
        :rows="30"
        placeholder="Please Paste"
        v-model="textareaPaste"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="importDialogVisible = false">{{
          $t("button.Cancel")
        }}</el-button>
        <el-button type="primary" @click="commitImport">{{
          $t("button.Confirm")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      importDialogVisible: false,
      textareaPaste: "",
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},

  methods: {
    open() {
      this.importDialogVisible = true;
    },
    handleClose() {
      this.importDialogVisible = false;
    },
    commitImport() {
      let firstChar = this.textareaPaste.charAt(0);
      let lastChar = this.textareaPaste.charAt(this.textareaPaste.length - 1);
      console.log(typeof this.textareaPaste);

      console.log(JSON.parse(this.textareaPaste));
      if (firstChar == "[" && lastChar == "]") {
        this.importDialogVisible = false;
        this.$emit("impotContent", this.textareaPaste);
        this.$message.success(this.$t("lcd.Editor.importSuccess"));
      } else {
        this.$message.error(this.$t("lcd.Editor.importRemind"));
      }
    },
  },
};
</script>
<style lang="scss">
</style>
